import {
  PlanComponent,
  PlanComponentCategory,
  ImpactByScopeAndCategory,
} from "@labs/shared/types/AnalyzedPlan.ts";
import { Scope } from "@labs/shared/types/Solution.ts";
import { scope1Fuels, scope2Fuels } from "../../data/scopeFuels.ts";

// todo: once we refactor the plan analysis to use a new data model, this kind of
// slicing and dicing should be unnecessary. so i haven't spent much time on
// making the implementation super nice. it is tested.
export const getImpactByScopeAndCategory = (
  allPlanComponents: PlanComponent[],
): ImpactByScopeAndCategory => {
  const impactByScopeAndCategory: ImpactByScopeAndCategory = {
    [Scope.Scope1]: {
      [PlanComponentCategory.CutEnergyWaste]: 0,
      [PlanComponentCategory.ElectrifyMobile]: 0,
      [PlanComponentCategory.ElectrifyStationary]: 0,
      [PlanComponentCategory.BuyClean]: 0,
      [PlanComponentCategory.Other]: 0,
    },
    [Scope.Scope2]: {
      [PlanComponentCategory.CutEnergyWaste]: 0,
      [PlanComponentCategory.BuyClean]: 0,
    },
    [Scope.Scope3]: {},
  };

  allPlanComponents.forEach((component) => {
    const { planComponentCategory, fuelImpacts } = component;

    fuelImpacts.forEach(({ fuelSource, carbonImpact }) => {
      if (scope1Fuels.includes(fuelSource)) {
        if (
          impactByScopeAndCategory[Scope.Scope1][planComponentCategory] !==
          undefined
        ) {
          impactByScopeAndCategory[Scope.Scope1][planComponentCategory]! +=
            carbonImpact;
        }
      } else if (scope2Fuels.includes(fuelSource)) {
        if (
          impactByScopeAndCategory[Scope.Scope2][planComponentCategory] !==
          undefined
        ) {
          impactByScopeAndCategory[Scope.Scope2][planComponentCategory]! +=
            carbonImpact;
        }
      }
    });
  });

  return impactByScopeAndCategory;
};
